import { render, staticRenderFns } from "./DynamicFormFieldTextarea.vue?vue&type=template&id=424da671&"
import script from "./DynamicFormFieldTextarea.vue?vue&type=script&lang=js&"
export * from "./DynamicFormFieldTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports